import { create, StoreApi, useStore } from 'zustand';

import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';
import { DrawFsetupToolModeEnum } from '@spazious/dollhouse-types';

interface Node {
  type: FShallowNodeTypesEnum;
  id: number;
}

export interface DrawFsetupState {
  node: Node | null;
  tool: DrawFsetupToolModeEnum;
  active: boolean;
}

export interface DrawFsetupStoreState extends DrawFsetupState {
  set: StoreApi<DrawFsetupState>['setState'];
  get: StoreApi<DrawFsetupState>['getState'];
}

const createDrawFsetupStore = (initialState?: Partial<DrawFsetupState>) =>
  create<DrawFsetupStoreState>((set, get) => ({
    set,
    get,
    node: null,
    tool: DrawFsetupToolModeEnum.Rectangle,
    active: false,
    ...initialState,
  }));

export const store = createDrawFsetupStore();

export const useDrawFsetup = () => {
  const state = useStore(store);
  const set = store.getState().set;
  const get = store.getState().get;

  return { ...state, set, get };
};
